import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=f285c6e4&scoped=true"
import script from "./Products.vue?vue&type=script&lang=ts"
export * from "./Products.vue?vue&type=script&lang=ts"
import style0 from "./Products.vue?vue&type=style&index=0&id=f285c6e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f285c6e4",
  null
  
)

export default component.exports